@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.FlyoverContent {
  @include boxShadowDistant();
  background: $system_white-lightest;
  border-radius: $border-radius-large;
  border: $border-standard;
  box-shadow:
    0px 6px 10px 0px rgba(0, 0, 0, 0.12),
    0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  max-height: max(
    243px,
    80vh
  ); // increasing this, some filters get really cut off, maybe we can just remove it?
  overflow: hidden;

  &_open {
    z-index: 102;
  }

  &_S {
    width: 200px;
  }
  &_M {
    width: 350px;
  }
  &_L {
    width: 500px;
  }

  &_fixedHeight {
    height: 289px;
  }

  &_fullHeight {
    max-height: 90vh;
  }
}

.Filter {
  padding: $size-XS;

  input {
    @include border-standard;
    padding: $size-XS $size-S;
    width: 100%;
  }
}

.Contents {
  flex: 1;
  overflow: auto;
  position: relative;
}
